import { render, staticRenderFns } from "./ReportsStudentExercisesItem.vue?vue&type=template&id=d25b3618&scoped=true&"
import script from "./ReportsStudentExercisesItem.vue?vue&type=script&lang=js&"
export * from "./ReportsStudentExercisesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25b3618",
  null
  
)

export default component.exports